import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { getWeeklyRewardHistory } from "store/actions";
import Table from "components/Table";
import Columns from "./Columns";
import FormikForm from "components/shared/FormikForm";
import moment from "moment";
import WeeklyRewardModal from "components/Modals/WeeklyReward/WeeklyRewardModal";
import { generateWeekOptions, generateYearOptions } from "constants";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search...",
  },
  {
    name: "weekNo",
    type: "select",
    label: "",
    placeholder: "Select Week...",
    options: generateWeekOptions("Etc/GMT-4", { weekStartsOn: 1 })
  },
  {
    name: "year",
    type: "select",
    label: "",
    placeholder: "Select Year...",
    options: generateYearOptions()
  }
];

const initialValuesForFilter = {
  search: "",
  weekNo: moment().tz("Etc/GMT-4").week(),
  year: moment().tz("Etc/GMT-4").year()
};

const List = () => {
  const dispatch = useDispatch();
  const { weeklyRewards, loading, totalWeeklyRewards } = useSelector(
    ({ Settings }) => Settings
  );
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  // const [showPicker, setShowPicker] = useState(false);
  const [rewardModalShow, setRewardModalShow] = useState(false);
  const [id, setId] = useState(null);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    weekNo: moment().week(),
    year: moment().year()
  });

  useEffect(() => {
    getApiData(filter);
    setcolumns(Columns({ handleEditHandler }));
  }, [filter]);

  async function getApiData(query) {
    try {
      dispatch(getWeeklyRewardHistory({ data: query }));
    } catch (error) { }
  }

  const handleEditHandler = (info) => {
    setId(info?._id);
    setRewardModalShow(true);
  };

  const handleFilterForm = (info) => {
    setFilter({
      ...filter,
      page: 1,
      limit: 20,
      order: -1,
      orderBy: "date_created_utc",
      search: info.search,
      status: info.status,
      weekNo: info.weekNo,
      year: info.year
    });
  };

  // const onClickExport = () => {
  //   dispatch(exportGameList({
  //     data: {
  //       startDate: filter.startDate, endDate: filter.endDate
  //     }
  //   }));
  // };

  // const handleSelect = (ranges) => {
  //   const { startDate, endDate } = ranges.selection;
  //   const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
  //   const formattedEndDate = moment(endDate).format("YYYY-MM-DD");
  //   setFilter((prevFilter) => ({
  //     ...prevFilter,
  //     startDate: formattedStartDate,
  //     endDate: formattedEndDate,
  //   }));
  //   setShowPicker(false);
  // };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      {rewardModalShow &&
        <WeeklyRewardModal
          show={rewardModalShow}
          handleClose={() => {
            setRewardModalShow(false);
            setId(null);
            getApiData(filter);
          }}
          title={"Reward Details"}
          id={id}
        />
      }
      <section className="section">
        <div className="section-header">
          <h1>Weekly Reward History</h1>

          {/* <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">Game History</div>
          </div> */}
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">History</h2>
                </div>
              </div>
              <div className="col-6">
                {/* <div className="card-header d-flex justify-content-end align-items-center">
                  <button
                    className="btn btn-primary"
                    onClick={() => onClickExport()}
                  >
                    Export
                  </button>
                </div> */}
              </div>
              <div className="col-12">
                <div className="card-header">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={loading}
                    inputFields={InputFieldsForSearch}
                    buttonText={"Search"}
                  // dateRange={filter}
                  // showPicker={showPicker}
                  // setShowPicker={setShowPicker}
                  // handleSelect={handleSelect}
                  />
                </div>
              </div>
            </div>
          </div>
          {weeklyRewards?.length > 0 && (
            <Table
              data={weeklyRewards}
              columns={columns}
              setFilter={setFilter}
              total={totalWeeklyRewards}
              filter={filter}
            />
          )}
          {!loading && weeklyRewards?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Record Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;